import type { HttpClient } from '@/lib/http/client.js'
import type { AuditEntry, AuditSearch, KeysetPage } from '@/types/audit/audit.type.js'

/** `admin/audit-logs`, verified against `audit-log.controller.ts`. Keyset, 50 by default. */
export interface AuditService {
  search: (query: AuditSearch) => Promise<KeysetPage<AuditEntry>>
}

export function createAuditService(http: HttpClient): AuditService {
  return {
    // `query` goes through the client's `buildUrl`, which drops `undefined` and `''` — an
    // empty filter must be absent, because the DTO validates whatever is present.
    search: (query) => http.get<KeysetPage<AuditEntry>>('admin/audit-logs', { query: { ...query } }),
  }
}
